import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';

export interface ProductPlan {
  id: number;
  productId: number;
  slug: string;
  name: string;
  order: number;
  active: boolean;
}

export function useProductPlans(productId: number | null) {
  return useQuery<{ data: ProductPlan[] }, Error, ProductPlan[]>({
    queryKey: ['product-plans', productId],
    queryFn: async () => {
      const r = await api.get(`/products/${productId}/plans`);
      return r.data;
    },
    select: (resp) => resp.data,
    enabled: !!productId,
  });
}
